import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';
class ExplanationFormModelAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'ExplanationFormModels';

  /**
   * Lấy danh sách dữ liệu thuyết minh theo dataType
   * @param {*} param
   * @returns
   * ltviet 06.03.2024
   */
  async getByDataType(param) {
    const request = {
      url: this.getAPIUrl(),
      data: param,
    };
    return await httpClient.getAsync(request);
  }
  /**
   * Lấy danh sách theo mẫu thuyết minh
   * @returns
   * tvtam 07.03.2024
   */
  async GetByExplanationForm(param) {
    const request = {
      url: this.getAPIUrl() + '/explanationFormModel',
      data: param,
    }
    return await httpClient.getAsync(request);
  }
  /**
   * Lấy dữ liệu dạng danh sách của dũ liệu thuyết minh theo id
   * @param {*} param
   * @returns
   * ltviet 06.03.2024
   */
  async getListTypeById(param) {
    const request = {
      url: this.getAPIUrl() + `/${param.explanModelId}/explanation-form-model-list-type`,
      data: param,
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Thêm mới trường dữ liệu
   * @param {*} param 
   * @returns 
   */
  async insertModel(param) {
    const request = {
      url: this.getAPIUrl() + '/explanationFormModel',
      data: {
        explanationFormModel: param.Model,
        explanationFormModelListTypes: param.SelectedFieldListValues,
        explanationFormModelReferences: param.ModelReferences
      },
    };
    return await httpClient.postAsync(request);
  }
  /**
   * Sửa trường dữ liệu
   * @param {*} param 
   * @returns 
   */
  async updateModel(param) {
    const request = {
      url: this.getAPIUrl() + '/explanationFormModel',
      data: {
        explanationFormModel: param.Model,
        explanationFormModelListTypes: param.SelectedFieldListValues,
        explanationFormModelReferences: param.ModelReferences
      },
    };
    return await httpClient.putAsync(request);
  }
  /**
   * Sửa cấu hình trường dữ liệu 
   * @param {*} param 
   * @returns 
   */
  async updateModelConfig(param) {
    const request = {
      url: this.getAPIUrl() + '/explanation-formModel-config',
      data: param,
    };
    return await httpClient.putAsync(request);
  }
  /**
   * Xóa trường dữ liệu
   * @param {*} param 
   * @returns 
   */
  async deleteModel(param) {
    const request = {
      url: this.getAPIUrl() + '/explanationFormModel',
      data: {
        explanationFormModel: param
      },
    };
    return await httpClient.deleteAsync(request);
  }

  /**
  * Lấy danh sách dữ liệu thuyết minh theo dataType
  * @param {*} param
  * @returns
  * tmnghia 15/03/2024
  */
  async getByListDataType(param) {
    const request = {
      url: this.getAPIUrl() + '/by-list-data-type',
      data: param,
    };
    return await httpClient.postAsync(request);
  }
  /**
   * Lấy dữ liệu reference theo idModel
   * @param {*} param
   * @returns
   * TMNghia 19/03/2024
   */
  async getModelReferences(param) {
    const request = {
      url: this.getAPIUrl() + `/${param.explanModelId}/explanation-form-model-reference`,
      data: param,
    };
    return await httpClient.getAsync(request);
  }
  /**  
   * Lấy nguồn dữ liệu dạng danh sách
   * @param {*} param
   * @returns
   */
  async getDictionaryDataByType(param) {
    const request = {
      url: this.getAPIUrl() + `/dictionary-source/${param.type}`,
      data: param,
    };
    return await httpClient.getAsync(request);
  }
  
  /**  
   * Lấy điều kiện lọc dữ liệu tiểu mục
   * @param {*} param
   * @returns
   */
  async getSubSectionDefaultFilter(param) {
    const request = {
      url: this.getAPIUrl() + '/sub-section-filter',
    };
    return await httpClient.getAsync(request);
  }
}

export default new ExplanationFormModelAPI();
